import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { GlobalService } from 'src/app/services/global.service';
import { AlertController } from '@ionic/angular';

@Component({
  selector: 'app-text-record',
  templateUrl: './text-record.component.html',
  styleUrls: ['./text-record.component.scss'],
})

export class TextRecordComponent implements OnInit{  
  @Input() initiator: string = "";
  @Input() text_info: any;



  
  textItems: any[] = []; // Array to store retrieved items
  currentIndex: number = 1; // Index to track current item
  currentText: any = null; // Current item to display
  errorMessage: string = '';
  languageText !: string;
  skipTextFun() {
      this.isRecording = false;

      this.endClick = false;
      this.startClick = false;

      this.pauseClick = false;
      this.audioChunks = [];
      this.recordedAudioUrl = '';


  }
  

  textFromServer:string = "";
  idOfTextFromServer:string = "";
  countOfTextPerUser:string = "";
  endClick:boolean = false;
  startClick:boolean = false;
  mediaRecorder: MediaRecorder | null = null;
  audioChunks: Blob[] = [];
  recordedAudioUrl: string | null = null;
  audioBlob: Blob | null = null;
  pauseClick:boolean = false;
  isRecording: boolean = false;
  isPlaying:boolean = false;
  isPaused = false; 

  audioInstance !: HTMLAudioElement;

  numberOfDataSave:number = 0;


  constructor(
    private modalCtrl:ModalController,
    private router:Router,
    private apiService:ApiService, 
    private globalService:GlobalService,
    private alertController: AlertController,
  ) {}

  ionViewWillLeave(): void {
    console.log("IonViewWillLeave called");
  }
  
  ngOnInit(){
    console.log("IIInitiator:",this.initiator);
    console.log("TText Info:",this.text_info);
  }
  

  async ionViewDidEnter(){
    console.log("ionViewDidEnter called");
  }

 
  

  startRecording() {
    this.startClick = true;
    navigator.mediaDevices.getUserMedia({ audio: true })
    .then((stream) => {
            this.isRecording = true;
            this.mediaRecorder = new MediaRecorder(stream);
            this.mediaRecorder.start();

            this.mediaRecorder.ondataavailable = (event) => {
                this.audioChunks.push(event.data);
            };

            this.mediaRecorder.onstop = () => {
                this.audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
                this.recordedAudioUrl = URL.createObjectURL(this.audioBlob);
            };
        })
        .catch((error) => {
            console.error('Error accessing microphone:', error);
        });
  }

  stopRecording() {
    this.isRecording = false;
    this.endClick = true;
    this.startClick = false;
    if (this.mediaRecorder) {
        this.mediaRecorder.stop();
      }
    setTimeout(() => {
      this.playRecording();
    }, 500);
  }

  stopRecordingOnly(){
    this.isRecording = false;
    this.endClick = true;
    this.startClick = false;
    if (this.mediaRecorder) {
        this.mediaRecorder.stop();
      }
  }

 
  playRecording() {
    if (this.isPlaying) {
        // If audio is already playing, pause it
        this.audioInstance.pause();
        this.isPlaying = false; // Update playing flag
        this.isPaused = true; // Set paused flag
    } else {
        if (this.recordedAudioUrl) {
            // If audio is not playing, start playing it
            this.audioInstance = new Audio(this.recordedAudioUrl);
            this.audioInstance.onended = () => {
                this.isPlaying = false;
                this.isPaused = false; // Reset paused flag
            };
            this.audioInstance.play();
            this.isPlaying = true;
            this.isPaused = false; // Reset paused flag
        }
    }
  }



  cleanRecording(){
    this.endClick = false;
    this.pauseClick = false;
    this.audioChunks = [];
    this.recordedAudioUrl = '';
    this.stopPlayingSound();
  }

  pauseRecording(){
    this.isRecording = false;
    this.endClick = true;
    this.startClick = false;
    this.pauseClick = true;
    if (this.mediaRecorder) {
      this.mediaRecorder.stop();
  }

  }

  continueRecording(){
    this.endClick = false;
    this.pauseClick = false;
    this.startRecording();
  }

  getTextModifiedDateById(textId: string): string | null {
    const item = this.textItems.find(item => item.TextId === textId);
    return item ? item.DateModified : null;
  }

  getUrlId(textId: string): string | null {
    const item = this.textItems.find(item => item.TextId === textId);
    return item ? item.Url : null;

    
  }


  saveRecording(){
    this.globalService.showLoading();
    this.stopPlayingSound();
    this.endClick = false;
    this.pauseClick = false;
    this.audioChunks = [];
    this.recordedAudioUrl = '';
    let idOfTextFromServer = this.text_info['TextId']
    const textdateModified = this.text_info['DateModified']
    const urlId = this.getUrlId(this.idOfTextFromServer);




    // apicall to store data 
    try{
            if (this.audioBlob) {
              
              // Proceed with the API call
              this.apiService.addAudio(this.audioBlob, idOfTextFromServer,textdateModified).subscribe(
                  async (response) => {
                          this.numberOfDataSave++;
                          console.log("Response after audio post:", response);

                          if(urlId){
                                console.log("make api call to update not recorded value")
                                this.apiService.removeRecordedWord(urlId, response["text"]).subscribe(
                                  (removeResponse) => {
                                    // Handle the response from the API call here
                                    console.log("Recorded word removed:", removeResponse);

                                    this.apiService.removeUrl(idOfTextFromServer).subscribe(
                                      async (response) => {
                                        console.log("Url from the data has been removed successfully.",response);
                                        
                                      },
                                      (err) => {
                                        console.error("Error during API call:", err);
                                      }
                                    );

                                    //call api to remove urls

                                  },
                                  (error) => {
                                    // Handle any errors that occurred during the API call
                                    console.error("Error occurred while removing recorded word:", error);
                                  }
                                );
                            
                          }



                         
                          
                          this.audioChunks = [];
                          this.recordedAudioUrl = '';
                          await this.globalService.dismissLoading();
                          // alert("Data has been saved");

                      },
                        (err) => {
                            console.error("Error during API call:", err);
                            alert("Failed to save data. Please try again.");
                            this.globalService.dismissLoading();

                        }
                    );
                } else {
                    console.warn("No audio data to save");
                    this.globalService.dismissLoading();

              }
        }catch (error) {
          console.error('Error saving data:', error);
          alert('Failed to save data. Please try again.');
          this.globalService.dismissLoading();
      }

  }

  closeModal(target:number) {
    if(this.numberOfDataSave !== 0){
      this.modalCtrl.dismiss(this.numberOfDataSave); 
    }else{
      this.modalCtrl.dismiss(0);
    }
  }


  async confirmLogout() {
    if(this.isRecording || this.hasUnsavedAudioData()){  
      const alert = await this.alertController.create({
            header: 'Confirm Logout',
            message: 'Are you sure you want to log out?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        // Do nothing when the user cancels
                    }
                },
                {
                    text: 'Logout',
                    handler: async () => {
                        this.stopRecordingOnly();
                        await this.LogoutFunction();
                    }
                }
            ]
        });

        await alert.present();
      }else{
        await this.LogoutFunction();
      }
  }

  async LogoutFunction(){
  
      try{
          this.globalService.logoutLoading();
          const res:any = await this.apiService.logoutUser().toPromise();
              

          localStorage.removeItem('authenticationKey');
          localStorage.removeItem('accent');
          localStorage.removeItem('age');
          localStorage.removeItem('gender');
          localStorage.removeItem('userId');
          localStorage.removeItem('userName');
          localStorage.removeItem('language');

          localStorage.removeItem('searchedText');
          localStorage.removeItem('selectedModel');
          localStorage.removeItem('selectedModelLanguageForTTS');
          localStorage.removeItem('selectedFilterValueForTTS');
          
          localStorage.removeItem('selectedOptionUser');
          localStorage.removeItem('textCategory');
          localStorage.removeItem('totalCountData');
          localStorage.removeItem('usersList');
          localStorage.removeItem('userRole');

          localStorage.removeItem('notRemoveModelInferencingData');

          this.stopPlayingSound();
          this.endClick = false;
          this.pauseClick = false;
          this.audioChunks = [];
          this.recordedAudioUrl = '';
          this.textFromServer = "";
          this.countOfTextPerUser = "";

          this.globalService.dismissLoading();
        
          this.router.navigate(['login']);



        
      
      }catch(error){
        console.log("Error:", error);
        this.globalService.dismissLoading();
        this.router.navigate(['login']);

      }
    


      
  };





  stopPlayingSound(){
    // Stop audio playback if the audio instance exists
    if (this.audioInstance) {
        this.audioInstance.pause();
        this.audioInstance.currentTime = 0; // Reset the audio time to the beginning
        this.isPlaying = false; // Reset the isPlaying flag
    }
  }

  hasUnsavedAudioData(): boolean {
      return this.audioChunks.length > 0;
  }



  

}